export default __webpack_public_path__ + "static/bestPortfolio-dce1606ce420738a0710f75bc56ec095.jpg";